import { createClient, type SupabaseClient } from '@supabase/supabase-js';
import type { Database } from '@/types/database';

/**
 * The one Supabase client. Browser code may hold exactly two values - the project URL and the
 * anon key (SUPABASE_CONNECTION.md, "Safety Rule"). The service role key and the database
 * password never reach this file.
 *
 * PostgREST is pointed at the `api` schema: it is the only application surface the database
 * exposes (views are `security_invoker`, so RLS still decides every row). `pub` holds the
 * pre-login lookups and is reached with `.schema('pub')`.
 */
const url = import.meta.env.VITE_SUPABASE_URL as string | undefined;
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined;

export const isSupabaseConfigured = Boolean(url && anonKey && !anonKey.startsWith('replace_with'));

export type VanamClient = SupabaseClient<Database, 'api'>;

let client: VanamClient | undefined;

export function getSupabase(): VanamClient {
  if (!isSupabaseConfigured) {
    throw new Error('Supabase is not configured: set VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY.');
  }
  client ??= createClient<Database, 'api'>(url!, anonKey!, {
    db: { schema: 'api' },
    auth: { persistSession: true, autoRefreshToken: true, detectSessionInUrl: false },
  });
  return client;
}
